<template>
  <el-dialog
    title="文件上传"
    :visible.sync="commandDialogVisible"
    width="70%"
    @close="closeFileUpload"
  >
    <el-card
      shadow="hover"
      body-style="padding: 2px"
      style="margin-right: 10px; margin-bottom: 10px"
    >
      <div slot="header" class="clearfix" style="height: 25px">
        <span style="font-weight: bold"
          ><el-tag>当前上传目录:{{ params.filePath }}</el-tag></span
        >
        <span>
          <el-switch
            v-model="value1"
            active-text="解压（注：在线解压时，压缩包不能设置密码）"
            @change="isActive"
          >
          </el-switch>
        </span>
      </div>
      <div>
        <uploader
          :autoStart="false"
          :options="options"
          :file-status-text="statusText"
          class="uploader-example"
          @file-complete="fileComplete"
          @complete="complete"
          @file-success="fileSuccess"
          @files-added="filesAdded"
        >
          <uploader-unsupport></uploader-unsupport>
          <uploader-drop>
            <p>拖动文件到此处</p>
            <uploader-btn>选择文件</uploader-btn>
            <!--        <uploader-btn :attrs="attrs">select images</uploader-btn>-->
            <!--        <uploader-btn :directory="true">select folder</uploader-btn>-->
          </uploader-drop>
          <!-- <uploader-list></uploader-list> -->
          <uploader-files> </uploader-files>
        </uploader>
        <br />
        <button @click="allStart()" :disabled="disabled">全部开始</button>
        <button @click="allStop()" :disabled="disabled">全部暂停</button>
        <button @click="allRemove()" :disabled="disabled">全部移除</button>
      </div>
    </el-card>
  </el-dialog>
</template>

<script>
import SparkMD5 from "spark-md5";
import { lib } from "@comm/assets/js/lib";
export default {
  data() {
    return {
      skip: false,
      options: {
        target: "/client/file/chunk",

        testMethod: "GET", //这里表示的是秒传的优先判断的请求方式
        uploadMethod: "POST", //这里表示的是发送文件流的请求方式
        // 开启服务端分片校验功能
        testChunks: true,
        parseTimeRemaining: function(timeRemaining, parsedTimeRemaining) {
          return parsedTimeRemaining
            .replace(/\syears?/, "年")
            .replace(/\days?/, "天")
            .replace(/\shours?/, "小时")
            .replace(/\sminutes?/, "分钟")
            .replace(/\sseconds?/, "秒");
        },
        // 服务器分片校验函数
        checkChunkUploadedByResponse: (chunk, message) => {
          const result = JSON.parse(message);
          if (result.data.skipUpload) {
            this.skip = true;
            return true;
          }
          return (result.data.uploaded || []).indexOf(chunk.offset + 1) >= 0;
        },
        query: (file, chunk) => {
          // console.log(file);
          return {
            ...file.params,
            isUncompress: this.value1
          };
        },
        headers: {
          "HEAD-CLUSTER-NAME": lib.cookie.get("HEAD-CLUSTER-NAME")
        }
      },
      attrs: {
        accept: "image/*"
      },
      statusText: {
        success: "上传成功",
        error: "上传出错了",
        uploading: "上传中...",
        paused: "暂停中...",
        waiting: "等待中...",
        cmd5: "计算文件MD5中..."
      },
      fileList: [],
      disabled: true,
      commandDialogVisible: false,
      params: {
        filePath: undefined
      },
      value1: false
    };
  },
  watch: {
    fileList(o, n) {
      this.disabled = false;
    }
  },
  methods: {
    isActive() {},
    decompression() {},
    showFileUpload(p) {
      this.params.filePath = p.path;
      this.commandDialogVisible = true;
    },
    fileSuccess(rootFile, file, response, chunk) {
      // console.log("上传成功");
      // console.log(chunk);
      const result = JSON.parse(response);
      // console.log(result);
      if (result.success && !this.skip) {
        // console.log("此时执行了");
        if (result.data.totalChunks != 1) {
          this.http
            .post("/client/file/merge", {
              identifier: file.uniqueIdentifier,
              filename: file.name,
              totalChunks: chunk.offset,
              filePath: this.params.filePath,
              isUncompress: this.value1
            })
            .then(res => {
              // console.log(res);
              if (res.data.success) {
              } else {
                // console.log(res);
              }
            })
            .catch(function(error) {
              // console.log(error);
            });
        }
        this.$emit("handleUploadSuccess", file);
      } else {
      }
      if (this.skip) {
        this.skip = false;
      }
    },
    fileComplete(rootFile) {
      // 一个根文件（文件夹）成功上传完成。
      // console.log("fileComplete", rootFile);
      // console.log("一个根文件（文件夹）成功上传完成。");
    },
    complete() {
      // 上传完毕。
      // console.log("complete");
    },
    filesAdded(file, fileList, event) {
      // console.log(file);
      // console.log(this.fileList);
      const MAX_FILE_SIZE = 1 * 1024 * 1024 * 1024; // 1GB
      if (file[0].size > MAX_FILE_SIZE) {
        this.$notify({
          title: "上传失败",
          message: "上传的文件大小不能超过1GB",
          type: "error",
          duration: 2000
        });
        file.ignored = true;
        return;
      }

      let index = false;
      let maxFlag = false;
      let flageFlag = false;
      let arr = [".mp4", ".rmvb", ".mkv", ".wmv", ".flv"];

      for (var i = 0; i < file.length; i++) {
        if (file[i].size / 1024 / 1024 / 1024 > 50) {
          maxFlag = true;
        }
        // console.log(file[i].name);
        // console.log(file[i].name.indexOf(".zip"));
        if (this.value1 && file[i].name.indexOf(".zip") == -1) {
          index = true;
        } else if (file[i].name.includes(" ")) {
          this.$message.warning("文件名不能包含空格");
          file.ignored = true;
          return;
        }

        arr.map(res => {
          // console.log("res是:", res);
          if (file[i].name.indexOf(res) != -1) {
            flageFlag = true;
            return;
          }
        });
      }
      if (maxFlag) {
        this.$notify({
          title: "上传失败",
          message: "文件大小不能超过50G",
          type: "error",
          duration: 2000
        });
        file.ignored = true;
      } else if (flageFlag) {
        this.$notify({
          title: "上传失败",
          message: "文件格式不能是视频格式",
          type: "error",
          duration: 2000
        });
        file.ignored = true;
      } else if (index) {
        this.$notify({
          title: "上传失败",
          message: "文件格式只能是.zip",
          type: "error",
          duration: 2000
        });
        file.ignored = true;
      } else {
        // console.log("此时上传");
        file.forEach(e => {
          this.fileList.push(e);
          this.computeMD5(e);
        });
      }
    },
    computeMD5(file) {
      // console.log(file);
      file.params = this.params;
      let fileReader = new FileReader();
      let time = new Date().getTime();
      let blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice;
      let currentChunk = 0;
      const chunkSize = 1024 * 1024;
      let chunks = Math.ceil(file.size / chunkSize);
      let spark = new SparkMD5.ArrayBuffer();
      // 文件状态设为"计算MD5"
      file.cmd5 = true; // 文件状态为“计算md5...”
      file.pause();
      // loadNext();
      fileReader.onload = e => {
        // console.log(e.target.result);
        spark.append(e.target.result);
        if (currentChunk <= chunks) {
          loadNext();
          currentChunk++;
        } else {
          let md5 = spark.end();
          // console.log(md5);
          spark.destroy(); // 释放缓存
          file.uniqueIdentifier = md5; // 将文件md5赋值给文件唯一标识
          file.cmd5 = false; // 取消计算md5状态
          // console.log(file);
          file.resume(); // 开始上传
        }
      };
      fileReader.onerror = function() {
        this.error(`文件${file.name}读取出错，请检查该文件`);
        file.cancel();
      };
      function loadNext() {
        let start = currentChunk * chunkSize;
        let end =
          start + chunkSize >= file.size ? file.size : start + chunkSize;
        fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end));
      }
    },
    allStart() {
      // console.log(this.fileList);
      this.fileList.map(e => {
        if (e.paused) {
          e.resume();
        }
      });
    },
    allStop() {
      this.$set(this.statusText, "paused", "暂停中...");
      // console.log(this.fileList, 111);
      this.fileList.map(e => {
        if (!e.paused) {
          e.pause();
        }
      });
    },
    allRemove() {
      this.fileList.map(e => {
        e.cancel();
      });
      this.fileList = [];
    },
    closeFileUpload() {
      this.commandDialogVisible = false;
      this.allRemove();
      this.$emit("handleUploadClosed", this.params);
    }
  }
};
</script>

<style>
.uploader-example {
  width: 880px;
  padding: 15px;
  margin: 40px auto 0;
  font-size: 12px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
}

.uploader-example .uploader-btn {
  margin-right: 4px;
}

.uploader-example .uploader-list {
  max-height: 440px;
  overflow: auto;
  overflow-x: hidden;
  overflow-y: auto;
}

.uploader-drop {
  background: none !important;
}

.uploader-file-progress {
  background: none !important;
}
</style>



// WEBPACK FOOTER //
// src/project2/components/file-transfer/SftpFileUpload.vue